import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { AuthInit } from './modules/auth'
import { CustomModal, ToastContainer } from './components'
import { BrandProvider } from './modules/brand-management/context/BrandContext'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrandProvider>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
              <CustomModal />
              <ToastContainer />
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </BrandProvider>
    </Suspense>
  )
}

export { App }
